import env from '@src/utils/env';
import service from './service';

/** @type {import('./tags.service').createTagPOST} */
export async function createTagPOST(params) {
  const response = await fetch(
    service(`${env.WEB_SERVICE_BASE_URI}/admin/tags/create`, { mock: false }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      cache: 'no-cache',
      body: JSON.stringify(params),
    }
  );

  if (response.ok) {
    return {};
  }
  return response.json();
}

/** @type {import('./tags.service').updateTagPOST} */
export async function updateTagPOST(params) {
  const response = await fetch(
    service(`${env.WEB_SERVICE_BASE_URI}/admin/tags/update`, { mock: false }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      cache: 'no-cache',
      body: JSON.stringify(params),
    }
  );

  if (response.ok) {
    return {};
  }
  return response.json();
}

/** @type {import('./tags.service').deleteTagPOST} */
export async function deleteTagPOST(params) {
  const response = await fetch(
    service(`${env.WEB_SERVICE_BASE_URI}/admin/tags/delete/:botId/:tagId`, {
      mock: false,
      params,
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      cache: 'no-cache',
    }
  );

  if (response.ok) {
    return {};
  }
  return response.json();
}

/** @type {import('./tags.service').searchTagPOST} */
export async function searchTagPOST(params, query, searchFilter) {
  const body = {
    filter: {
      searchFilter,
      stateFilter: null,
    },
    sorting: [
      {
        column: 'tag_name', //this iteration only includes this column
        direction: 'ASC', // ASC or DESC
      },
    ],
  };

  const response = await fetch(
    service(`${env.WEB_SERVICE_BASE_URI}/admin/tags/search/:botId`, {
      mock: false,
      params,
      query,
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      cache: 'no-cache',
      body: JSON.stringify(body),
    }
  );
  if (response.ok) return response.json();

  return [];
}

/** @type {import('./tags.service').searchChatTagsPOST} */
export async function searchChatTagsPOST(params) {
  const body = {
    filter: {
      searchFilter: '',
      stateFilter: true,
    },
    sorting: [
      {
        column: 'tag_name', //this iteration only includes this column
        direction: 'ASC', // ASC or DESC
      },
    ],
  };
  const url =
    typeof params.departmentId === 'number'
      ? `${env.WEB_SERVICE_BASE_URI}/services/tags/search/:botId/:departmentId/:chatId`
      : `${env.WEB_SERVICE_BASE_URI}/services/tags/search/:botId/:chatId`;

  const response = await fetch(service(url, { mock: false, params }), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    cache: 'no-cache',
    body: JSON.stringify(body),
  });
  if (response.ok) return response.json();

  throw response.json();
}

/** @type {import('./tags.service').deleteChatTagPOST} */
export async function deleteChatTagPOST(params) {
  const response = await fetch(
    service(
      `${env.WEB_SERVICE_BASE_URI}/services/tags/deleteFromChat/:chatId`,
      {
        params: { chatId: params.chatId },
      }
    ),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      cache: 'no-cache',
      body: JSON.stringify(params.tag),
    }
  );

  if (response.ok) {
    return {};
  }
  return response.json();
}

/** @type {import('./tags.service').assignChatTag} */
export async function assignChatTagPOST(params) {
  const response = await fetch(
    service(`${env.WEB_SERVICE_BASE_URI}/services/tags/assign/:chatId`, {
      params: { chatId: params.chatId },
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      cache: 'no-cache',
      body: JSON.stringify(params.tag),
    }
  );

  if (response.ok) {
    return {};
  }
  return response.json();
}

/** @type {import('./tags.service').adminSearchTagPOST} */
export async function adminSearchTagPOST(params) {
  const body = { filter: { searchFilter: '' } };
  const response = await fetch(
    service('admin/tags/search/:botId', { params }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      cache: 'no-cache',
      body: JSON.stringify(body),
    }
  );

  if (response.ok) return response.json();
  return [];
}
